import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createBlock(_component_Breadcrumb, {
    home: _ctx.home,
    model: _ctx.menuItems
  }, null, 8, ["home", "model"]))
}